module.exports = __webpack_public_path__ + "static/media/favorites.de293a55.webp";